import { useState, useEffect, useMemo } from 'react';
import { useAuth } from '../../auth/services/authService';
import { subscribeToNotifications, markNotificationAsRead, markAllNotificationsAsRead } from '../services/sellerNotificationService';

export const useSellerNotifications = () => {
  const { user } = useAuth();
  const [snapshot, setSnapshot] = useState({ uid: null, notifications: [] });

  useEffect(() => {
    if (!user?.uid) return;

    const uid = user.uid;
    const unsubscribe = subscribeToNotifications(uid, (data) => {
      setSnapshot({ uid, notifications: data });
    });

    return () => unsubscribe();
  }, [user?.uid]);

  const activeUid = user?.uid || null;
  const notifications = activeUid && snapshot.uid === activeUid ? snapshot.notifications : [];
  const loading = Boolean(activeUid) && snapshot.uid !== activeUid;

  const unreadCount = useMemo(() => {
    return notifications.filter(n => !n.isRead).length;
  }, [notifications]);

  const markAsRead = async (id) => {
    // Optimistic update could be added here, but the listener is fast enough usually
    await markNotificationAsRead(id);
  };
  
  const markAllRead = async () => {
    if (activeUid) {
      await markAllNotificationsAsRead(activeUid);
    }
  };

  return {
    notifications,
    unreadCount,
    loading,
    markAsRead,
    markAllRead
  };
};
